import { priceTooltipToggleTpl } from '../priceToggle/priceToggleTpl';

/**
 * Domain Highlights template
 * @param domainHighlight_datas
 * @return {string} - Formatted HTML
 */
export const domainHighlightTpl = (domainHighlight_datas) => {
  const item = domainHighlight_datas.product_datas;
  const blockClass = typeof domainHighlight_datas.blockClass === 'string' ? domainHighlight_datas.blockClass : '';
  const photoUrl = item.photo && item.photo['500x375'].length ? GLOBAL_SCRIPTS.BASELINK_MEDIA + item.photo['500x375'][0] : GLOBAL_SCRIPTS.STATIC_VERSION + '/assets/images/default/500x375.jpg';
  const datesFromToString = datesFromTo(item.cache.date, item.cache.dateEnd, GLOBAL_SCRIPTS.WORDINGS_COMMON.from_month, GLOBAL_SCRIPTS.WORDINGS_COMMON.to_month);
  const htmlLabel = item.offer.isNew || item.offer.isRenovated ? `<span class="domainHighlight-new">${item.offer.isNew ? domainHighlight_datas.labelNew : domainHighlight_datas.labelRenovated}</span>` : '';
  const countryName = typeof item.country.name === typeof {} ? Object.values(item.country.name)[0] : item.country.name;
  const htmlGeo = countryName !== '' || item.region.name !== '' ? `<p class="domainHighlight-geo">${[countryName, item.region.name].filter(v => v).join(', ')}</p>` : '';

  let htmlNote = '';
  let htmlDuration = '';
  let tooltipDurationLabel = '';

  if (datesFromToString !== '') {
    htmlDuration += `<p class="domainHighlight-duration">${datesFromToString}`;
    tooltipDurationLabel += `${datesFromToString}`;

    if (item.cache.duration > 0) {
      htmlDuration += `(${item.cache.duration + 1} ${GLOBAL_SCRIPTS.WORDINGS_COMMON.days} - ${item.cache.duration} ${GLOBAL_SCRIPTS.WORDINGS_COMMON.nights})`;
      tooltipDurationLabel += ` (${item.cache.duration} ${GLOBAL_SCRIPTS.WORDINGS_COMMON.nights})`;
    }
    htmlDuration += '</p>';
  }

  const htmlCurrency = `<span class="currency">${GLOBAL_SCRIPTS.CURRENCY_SYMBOL}</span>`;
  const priceFormatted = `${!GLOBAL_SCRIPTS.CURRENCY_IS_AFTER ? htmlCurrency : ''}<span class="price">${item.cache.price.original.value}</span>${GLOBAL_SCRIPTS.CURRENCY_IS_AFTER ? htmlCurrency : ''}`;

  let htmlPrice = `<span class="realPrice">${priceFormatted}</span>`;

  if (item.cache.price.promo.value > 0 && item.cache.price.promo.value < item.cache.price.original.value) {
    htmlPrice = `<span class="crossedPrice">${priceFormatted}</span><span class="realPrice">${!GLOBAL_SCRIPTS.CURRENCY_IS_AFTER ? htmlCurrency : ''}<span class="price">${item.cache.price.promo.value}</span>${GLOBAL_SCRIPTS.CURRENCY_IS_AFTER ? htmlCurrency : ''}</span>`;
  }

  const includedServices = [];

  if (typeof item.housing.servicesIncludedV2 !== 'undefined' && item.housing.servicesIncludedV2.length) {
    $.each(item.housing.servicesIncludedV2, (i, service) => {
      if (service.regroupement === 'PRICEINCLUDE') {
        includedServices.push(service.name.replaceAll('\'', '’').replaceAll('"', '’'));
      }
    });
  }

  const htmlPriceTooltipToggle = priceTooltipToggleTpl({
    blockClass: 'domainHighlight-tooltip',
    trackingPriceTooltipGaAction: 'bloc cross-sell',
    tooltipOptions: {
      includedServices: includedServices,
      typeTooltip: 'domaine',
      totalParticipants: domainHighlight_datas.totalParticipants,
      participants: domainHighlight_datas.participants,
      taxTotal: item.cache.price.taxTotal,
      originalPrice: item.cache.price.original.value,
      originalPriceRaw: item.cache.price.original.raw,
      originalPriceRawBeforeTax: item.cache.price.original.rawBeforeTax,
      petsPrice: item.cache.price.pets.rawBeforeTax,
      differencePrice: item.cache.price.difference,
      differencePriceRaw: item.cache.price.rawDifference,
      discountLabel: typeof item.actionCode.name !== 'undefined' && item.actionCode.name !== null && item.actionCode.name.length ? item.actionCode.name.replaceAll('\'', '’').replaceAll('"', '’') : (domainHighlight_datas[genericDate.diff(new Date(), new Date(item.cache.date)) > 60 ? 'early_booking_label' : 'last_minute_label']),
      housingLabel: item.housing.housingType.name.replaceAll('\'', '’').replaceAll('"', '’') + ' ' + item.housing.comfortLevel.name + (item.housing.isRenovated ? ' ' + GLOBAL_SCRIPTS.WORDINGS_CROSSSELL.label_renovated : ''),
      dateLabel: tooltipDurationLabel,
      maxPersons: item.cache.maxPersons,
      isLikeFancy: true,
      brandCode: typeof item.brand !== typeof undefined && typeof item.brand.code !== typeof undefined ? item.brand.code : null,
      productCode: item.cache.offerCode
    }
  });

  const geoDistance = item.extra.geo_distance ? `<span class="domainHighlight-distance"><i class="icon icon-arrow-diagonal"></i>${parseInt(item.extra.geo_distance, 10)} km</span>` : '';

  return `<a class="domainHighlight${blockClass !== '' ? ` ${blockClass}` : ''}${item.housing.uri !== '' ? ' js-postParams' : ''}" href="${GLOBAL_SCRIPTS.BASELINK}/${item.offer.url.split('?')[0]}"${item.housing.uri !== '' ? ` data-urlparams="${item.housing.uri}"` : ''}>
    <div class="domainHighlight-visual">
      <picture class="domainHighlight-img withBackgroundColor">
        <img class="lazy" data-src="${photoUrl}" alt="${item.offer.name}" itemprop="image">
        <div class="cp-spinner"><i></i></div>
      </picture>
      ${geoDistance}
    </div>
    <div class="domainHighlight-content">
      <div class="domainHighlight-content-header">
        <h3 class="domainHighlight-parkname">${item.offer.name}${htmlNote}</h3>
        ${htmlLabel}
      </div>
      ${htmlGeo}
      <div class="domainHighlight-priceBlock">
        ${htmlDuration}
        <div class="domainHighlight-priceValue">
          ${GLOBAL_SCRIPTS.WORDINGS_COMMON.from_price.charAt(0).toUpperCase() + GLOBAL_SCRIPTS.WORDINGS_COMMON.from_price.slice(1)}
          ${htmlPrice}
          ${htmlPriceTooltipToggle}
        </div>
      </div>
    </div>
  </a>`;
};